import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const updateSelectedVariants = async (fileId, rowData, operationType) => {
  const { data } = await axios.post(`${API_BASE_URL}/selected-variants`, {
    fileId,
    operationType,
    rowData,
  })
  return data
}
